import React from "react";
import pulse from "../assets/Pulse.gif";

export default function LoadingComponent() {
  return (
    <div className="">
      <div className="fixed flex justify-center items-center inset-0  bg-blue-200 z-50 bg-opacity-75  ">
        <div className="absolute  z-50   mx-auto ">
          <div className="p-12">
            <img src={pulse} alt="gif" height={50} width={50} />
          </div>
        </div>
      </div>
    </div>
  );
}
